
import React, { ReactElement } from 'react';
import LazyImage from 'react-lazy-progressive-image';
import ImageSkeleton from '@components/skeletons/ImageSkeleton';

type ImageProps = {
    width: string;
    height: string;
    src: string;
    alt: string;
    placeholder?: string;
    className?: string;
    onLoad?: any;
}

const Image = (props: ImageProps) : ReactElement => {

    const {
        width,
        height,
        src,
        alt,
        placeholder,
        className,
        onLoad
    } = props;

    return(
        <LazyImage
            placehoder={placeholder}
            src={src}
            visibilitySensorProps={{ partialVisibility: true, offset: { bottom: -100, right: -100 } }}
        >
            {(src, loading) => {
                return loading ? 
                    <ImageSkeleton width={width} height={height} />
                    :
                    <img src={src} 
                        alt={alt}
                        draggable={false}
                        class={className}
                        onLoad={onLoad}
                     />
                }
            }
        </LazyImage>
    )
}

export default Image;